import React from "react";

const STATUS_STYLES = {
  verified: "bg-success-soft text-success border-success",
  pending: "bg-warning-soft text-warning border-warning",
  failed: "bg-danger-soft text-danger border-danger",
};

const STATUS_LABELS = {
  verified: "Verified",
  pending: "Pending",
  failed: "Failed",
};

const ConnectionStatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES.pending;
  const label = STATUS_LABELS[status] || STATUS_LABELS.pending;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium border ${style}`}>
      {label}
    </span>
  );
};

export default ConnectionStatusBadge;
